import { Retailer_Network_User_Role, User_Role } from '@occc/graphql';

import { getAllFeatures, getAllReadOnlyFeatures } from './utils';

import { AccessControlMatrix } from './access-control-context';
import { Feature } from './types';

const allFeatures = getAllFeatures();
const allReadOnlyFeatures = getAllReadOnlyFeatures();

const scanDataFeatures = [
  Feature.SCAN_DATA_VIEW,
  Feature.SCAN_DATA_EDIT,
  Feature.SCAN_DATA_DOWNLOAD_CSV,
  Feature.SCAN_DATA_SUBMIT_WEEKLY_FILE,
  Feature.SCAN_DATA_SUBMISSION_GROUPS_VIEW,
  Feature.SCAN_DATA_SUBMISSION_GROUPS_CREATE,
  Feature.SCAN_DATA_SUBMISSION_GROUPS_EDIT,
  Feature.SCAN_DATA_SUBMISSION_GROUPS_ADD_REMOVE_LOCATIONS,
];

export const defaultAccessControlMatrix: AccessControlMatrix = [
  [
    User_Role.Support,
    null,
    [
      Feature.MEMBERS_VIEW,
      Feature.MEMBER_VIEW,
      Feature.MEMBER_EDIT,
      Feature.ALLOW_LIST_VIEW,
      Feature.AUDIENCES_VIEW,
      Feature.AUDIENCE_VIEW,
      Feature.AUDIENCE_EDIT_VIEW_ONLY,
      Feature.SURVEYS_VIEW,
      Feature.SURVEY_VIEW,
      Feature.SURVEY_EDIT_VIEW_ONLY,
      Feature.CAMPAIGNS_VIEW,
      Feature.CAMPAIGN_VIEW,
      Feature.CAMPAIGN_COMPONENTS_VIEW,
      Feature.CAMPAIGN_COMPONENT_VIEW,
      Feature.CAMPAIGN_COMPONENT_EDIT_VIEW_ONLY,
      Feature.TRANSACTIONS_VIEW,
      Feature.TRANSACTION_VIEW,
      Feature.LOCATIONS_VIEW,
      Feature.LOCATION_VIEW,
      Feature.LOCATION_EDIT_VIEW_ONLY,
      Feature.PROGRAM_MANAGEMENT_VIEW,
      Feature.PRODUCT_GROUPS_VIEW,
      Feature.PRODUCT_GROUP_VIEW,
      Feature.AWARDS_VIEW,
      Feature.AWARD_VIEW,
      Feature.AWARD_EDIT_VIEW_ONLY,
      Feature.LOYALTY_EVENTS_VIEW,
      Feature.LOYALTY_EVENT_VIEW,
      Feature.LOYALTY_EVENT_EDIT_VIEW_ONLY,
      Feature.TRIGGERED_MESSAGES_VIEW_ONLY,
      Feature.TOUCHPOINT_VIEW,
      Feature.TOUCHPOINT_AD_SETS_VIEW,
      Feature.TOUCHPOINT_AD_SET_VIEW,
      Feature.TOUCHPOINT_ASSETS_VIEW,
      Feature.TOUCHPOINT_ASSET_VIEW,
      Feature.TOUCHPOINT_DEFAULT_SCREENS_VIEW,
      Feature.TOUCHPOINT_DEFAULT_SCREEN_VIEW,
      Feature.TOUCHPOINT_DEFAULT_SCREEN_EDIT_VIEW_ONLY,
      Feature.DRIVE_INSIGHTS_VIEW,
    ],
  ],
  [User_Role.Admin, null, allFeatures.filter((feature) => !scanDataFeatures.includes(feature))],
  [User_Role.AdminReadOnly, null, [...allReadOnlyFeatures, Feature.AUDIENCE_EXPORT]],
  [
    User_Role.ScanDataAdmin,
    null,
    [
      ...allReadOnlyFeatures,
      Feature.USER_MANAGEMENT_VIEW,
      Feature.OFFERS_VIEW,
      Feature.OFFER_VIEW,
      ...scanDataFeatures,
    ],
  ],
  [
    User_Role.ScanDataUser,
    null,
    [
      ...allReadOnlyFeatures,
      Feature.USER_MANAGEMENT_VIEW,
      Feature.OFFERS_VIEW,
      Feature.OFFER_VIEW,
      Feature.SCAN_DATA_VIEW,
      Feature.SCAN_DATA_SUBMISSION_GROUPS_VIEW,
    ],
  ],
  [
    User_Role.Sitetech,
    null,
    [
      Feature.LOCATIONS_VIEW,
      Feature.LOCATION_VIEW,
      Feature.LOCATION_CREATE,
      Feature.LOCATION_EDIT,
      Feature.LOCATION_ISSUES_VIEW,
      Feature.LOCATION_ISSUE_EDIT,
      Feature.LOCATION_ISSUE_DELETE,
    ],
  ],
  // These permissions are used to render Sidebar items
  // Later when the whole CC will migrate to the new Policy Based permissions approach
  // we have to rewrite the Sidebar items render logic
  [
    User_Role.RcUser,
    Retailer_Network_User_Role.RetailerNetworkAdmin,
    [Feature.RETAILER_NETWORKS_VIEW, Feature.RETAILER_NETWORK_USER_MOBILE_PHONE_VIEW],
  ],
  [
    User_Role.RcUser,
    Retailer_Network_User_Role.RetailerNetworkUser,
    [Feature.RETAILER_NETWORKS_VIEW, Feature.RETAILER_NETWORK_USER_MOBILE_PHONE_VIEW],
  ],
  [
    User_Role.RcUser,
    Retailer_Network_User_Role.SiteAdmin,
    [
      Feature.RETAILER_NETWORK_SITE_ROLES_HOME_PAGE_VIEW,
      Feature.RETAILER_NETWORK_USER_MOBILE_PHONE_VIEW,
    ],
  ],
  [
    User_Role.RcUser,
    Retailer_Network_User_Role.SiteUser,
    [
      Feature.RETAILER_NETWORK_SITE_ROLES_HOME_PAGE_VIEW,
      Feature.RETAILER_NETWORK_USER_MOBILE_PHONE_VIEW,
    ],
  ],
];
